import PropTypes from "prop-types";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const ImageSlider = ({ images }) => {
  return (
    <div className="col-lg-8">
      <Swiper
        loop={true}
        pagination={{
          type: "bullets",
          clickable: true,
        }}
        modules={[Autoplay, Pagination]}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        className="portfolio-details-slider"
      >
        <div className="swiper-wrapper align-items-center">
          {images.map((src, index) => (
            <SwiperSlide key={index} className="swiper-slide">
              <img src={src} alt={`slide-${index + 1}`} />
            </SwiperSlide>
          ))}
        </div>
      </Swiper>
    </div>
  );
};

ImageSlider.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default ImageSlider;
